<template>
  <section id="country-tab-when-to-travel" class="wrapper-tab-when-to-travel">
    <h2 class="subtitle-content">{{
      $t(`${base}.title`, { name: country.name })
    }}</h2>

    <LadAdvancedTabs
      :base="`${base}.tabs`"
      :tabs="tabs"
      :custom-tabs="true"
      :tabs-id="`when-to-travel-tab`"
      :default-step="currentTab"
      @tab-click="handleClick"
      @current-tab="updateCurrentTab"
    >
      <p>{{ descriptions[currentTab] }}</p>
    </LadAdvancedTabs>

    <LadCountryWeatherInformation :md="24" />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import LadAdvancedTabs from '@/components/advanced-tabs'

export default {
  name: 'LadSearchTabWhenToTravel',
  components: {
    LadAdvancedTabs,
    LadCountryWeatherInformation: () =>
      import(
        /* webpackChunkName: "lad-country-weather-information" */ '@/components/pages/search/country/partials/weather-information'
      ),
  },
  data() {
    return {
      base: 'search.country.when_to_travel',
      currentTab: 'summer',
    }
  },
  computed: {
    ...mapState('country', {
      country: (state) => ({ name: state.header.name }),
      tabs: (state) =>
        state.when_travel.map((item) => ({
          slug: item.slug,
          title: item.title,
        })),
      descriptions: (state) =>
        state.when_travel.reduce((prev, current) => {
          prev[current.slug] = current.description
          return prev
        }, {}),
    }),
  },
  methods: {
    handleClick(tab, event) {},
    updateCurrentTab(tab) {
      this.currentTab = tab
    },
  },
}
</script>

<style lang="scss">
section.wrapper-tab-when-to-travel {
  .lad-country--weather {
    flex-direction: column;
    row-gap: 20px;
    margin-top: 20px;

    .el-card__body {
      min-height: 365px;
    }
  }
}
</style>
